import classNames from 'classnames'
import type { ReactElement } from 'react'
import styles from './index.module.css'
import type { IconName } from './names'
import { renderGlyph } from './renderGlyph'
import type { GlyphProps, IconSize, IconVariant } from './types'

export type IconProps = {
  icon: IconName
  variant?: IconVariant
  size?: IconSize
  spin?: boolean
  fixedWidth?: boolean
  flip?: boolean
  title?: string
} & Omit<GlyphProps, 'name' | 'variant' | 'size' | 'flip' | 'title'>

export function Icon({
  icon,
  variant = 'regular',
  spin,
  fixedWidth,
  className,
  ...rest
}: IconProps): ReactElement | null {
  return renderGlyph({
    ...rest,
    name: icon,
    variant,
    className: classNames(styles.glyph, spin && styles.spin, fixedWidth && styles.fixedWidth, className)
  })
}
